import { useState } from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  makeStyles,
} from '@material-ui/core';
import { useSnackbar } from 'notistack';

import DialogHeader from 'components/DialogHeader';
import { useAppDispatch, useAppSelector } from 'store';
import { CanalInterface } from 'store/reducers/canais';
import {
  gruposSelector,
  setCanalSelecionadoId,
  setChannelPreference,
} from 'store/reducers/grupos';

import CanalMenuItem from './CanalMenuItem';

const useStyles = makeStyles(({ spacing }) => ({
  dialogPaper: {
    width: '100%',
    maxWidth: 450,
    borderRadius: spacing(1.5),
  },
}));

interface ModalSeletorCanalProps {
  open: boolean;
  onClose: () => void;
  canais: CanalInterface[];
  selectedCanalId?: string;
}

export default function ModalSeletorCanal({
  open,
  onClose,
  canais,
  selectedCanalId,
}: ModalSeletorCanalProps) {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [selected, setSelected] = useState<string | undefined>(selectedCanalId);

  const dispatch = useAppDispatch();
  const { loadingCanalPreferencia, grupoSelecionado } =
    useAppSelector(gruposSelector);

  const handleConfirm = () => {
    if (selected && grupoSelecionado) {
      dispatch(
        setChannelPreference({
          grupoId: grupoSelecionado.id,
          canalId: selected,
        }),
      )
        .unwrap()
        .then(({ canalId }) => {
          dispatch(setCanalSelecionadoId(canalId));
          enqueueSnackbar('Canal principal definido com sucesso.');
          onClose();
        })
        .catch(error => {
          enqueueSnackbar(error.message, { variant: 'error' });
        });
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      classes={{ paper: classes.dialogPaper }}
    >
      <DialogHeader
        title="Escolha um canal"
        description="Selecione o canal que será utilizado para enviar mensagem neste grupo."
        onClose={onClose}
      />

      <DialogContent>
        {canais.map(canal => (
          <CanalMenuItem
            key={canal.id}
            canal={canal}
            isSelected={selected === canal.id}
            disabled={loadingCanalPreferencia}
            onClick={() => setSelected(canal.id)}
          />
        ))}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleConfirm}
          disabled={!selected || loadingCanalPreferencia}
        >
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
